module.exports = __webpack_public_path__ + "static/logo-45c9b079e926db1d7605606687e6ee54.svg";